import { h as l } from "vue";
import t from "./ghl-ui.es343.js";
const d = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  padding: "8px",
  width: "100%"
}, g = (e, r) => l(
  "div",
  {
    style: {
      display: "flex",
      alignItems: "center"
    }
  },
  [
    l(
      "div",
      {
        style: d
      },
      [
        l(
          "p",
          {
            style: {
              margin: 0,
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden"
            }
          },
          { default: () => e == null ? void 0 : e.label }
        ),
        l(
          "span",
          {
            style: {
              color: e.disabled ? "var(--gray-300)" : "var(--gray-500)"
            }
          },
          {
            default: () => e != null && e.description ? e == null ? void 0 : e.description : void 0
          }
        )
      ]
    )
  ]
), f = ({ option: e }) => e.label, i = ({
  option: e,
  handleClose: r
}) => l(
  t,
  {
    closable: !0,
    onClose: (a) => {
      a.stopPropagation(), r();
    }
  },
  {
    default: () => e.label
  }
);
export {
  g as defaultRenderLabel,
  i as renderMultipleSelectTag,
  f as renderSingleSelectTag
};
